import styled from "styled-components";

export const StyledLogin = styled.div`
  min-height: 100vh;
  ul,
  ol {
    padding-left: 24px;
  }

  #customerIdentifier {
    padding: 10px 4px 10px 0px;
  }

  .error-screen-web {
    display: block;
  }

  .error-screen-mob {
    display: none;
  }

  .hero-logo {
    display: ${(props) =>
      props.desktopCoverImageVisibility ? "flex" : "none"};
    height: 100vh;
    align-items: center;
    justify-content: center;
  }

  .login-wrapper {
    background: ${(props) =>
      props.desktopCoverImageVisibility
        ? `url(${props.coverImage}) center / cover no-repeat`
        : "transparent"};
    object-fit: cover;
    display: flex;
    align-items: center;
    padding: 5rem;
    min-height: 100vh;
  }

  .login-section {
    min-height: 100vh;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: ${(props) =>
      props.desktopCoverImageVisibility ? "20px 20px 0px" : "0px 6rem"};

    .brand-logo {
      display: ${(props) =>
        props.desktopBrandImageVisibility ? "block" : "none"};
      max-height: 60px;
      margin: 0 auto 1rem;
      height: 100%;
      width: auto;
    }

    .return-to-store-link {
      position: fixed;
      top: 0px;
      left: 0px;
      z-index: 20;
      width: fit-content;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      color: #3B444D;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
      border-radius: 0px 0px 10px 0px;
      padding: 5px 10px;
    }

    .return-to-store-link:hover .return-to-store-text {
      text-decoration: underline;
      text-underline-offset: 2px;
    }

    .return-to-store-arrow {
      font-size: 14px;
      line-height: 1;
    }

    .return-to-store-text {
      text-decoration: none;
    }

    .return-title {
      font-size: 1.5rem;
      margin-bottom: 20px;
      font-weight: 700;
      max-width: 450px;
      width: 100%;
      color: ${(props) => props.themeColor};
    }

    .input-label {
      font-size: 14px;
      margin: 10px 0px 0px;
      color: #3B444D;
    }

    .brand-note {
      max-width: 450px;
      width: 100%;
      font-size: 14px;
      line-height: 2;
      margin-top: 30px;
    }
  }

  .otp-input {
    width: 50px;
    height: 50px;
    font-size: 22px;
    text-align: center;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .otp-input:focus {
    border-bottom: ${(props) =>
      props.themeColor
        ? `2px solid ${props.themeColor}`
        : "2px solid rgba(217, 217, 217, 1)"} !important;
  }

  @media (max-width: 800px) {
    .hero-logo {
      height: 35vh;
      display: ${(props) =>
        props.mobileCoverImageVisibility ? "flex" : "none"};
    }

    .login-wrapper {
      background: ${(props) =>
        props.mobileCoverImageVisibility
          ? `url(${props.coverImage}) center / cover no-repeat`
          : "transparent"};
      padding: 1.5rem;
      display: flex;
    }

    .login-section {
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      padding: 30px;
      min-height: 65vh;
      height: auto;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.35);
      justify-content: flex-start;

      .brand-logo {
        display: ${(props) =>
          props.mobileBrandImageVisibility ? "block" : "none"};
        max-width: 100px;
      }

      .return-to-store-link {
        top: 16px;
        left: 16px;
      }

      .return-title {
        font-size: 18px;
        margin: 15px 0px 20px;
      }

      .input-label {
        font-size: 14px;
      }

      .brand-note {
        font-size: 12px;
      }
    }

    .error-screen-mob {
      display: block;
    }

    .error-screen-web {
      display: none;
    }

    .otp-input {
      margin-left: 10px;
      width: 40px;
      height: 40px;
      font-size: 1rem;
    }
  }
`;

export const StyledDrawerTnC = styled.div`
  padding: 20px;
  line-height: 1.5rem;
  max-height: 90vh;
  color: #333;
  font-size: 12px;
  overflow: hidden;

  ul,
  ol {
    padding-left: 20px;
  }
`;
